"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.spec = exports.Methods = void 0;
const contract_1 = require("@stellar/stellar-sdk/contract");
var Methods;
(function (Methods) {
    Methods["deposit"] = "deposit";
    Methods["withdraw"] = "withdraw";
    Methods["getEstimatedYield"] = "get_estimated_yield";
    Methods["getPosition"] = "get_position";
    Methods["getEstimatedPrematureWithdraw"] = "get_estimated_premature_withdraw";
    Methods["getTimeLeft"] = "get_time_left";
    Methods["extendContractValidity"] = "extend_contract_validity";
    Methods["initialize"] = "initialize";
})(Methods || (exports.Methods = Methods = {}));
exports.spec = new contract_1.Spec([
    'AAAAAAAAAAAAAAAKaW5pdGlhbGl6ZQAAAAAACAAAAAAAAAAFYWRtaW4AAAAAAAATAAAAAAAAAAVhc3NldAAAAAAAABMAAAAAAAAABHRlcm0AAAAGAAAAAAAAAA1jb21wb3VuZF9zdGVwAAAAAAAABgAAAAAAAAAKeWllbGRfcmF0ZQAAAAAABgAAAAAAAAALbWluX2RlcG9zaXQAAAAACwAAAAAAAAAMcGVuYWx0eV9yYXRlAAAABgAAAAAAAAAQYWxsb3dhbmNlX3BlcmlvZAAAAAQAAAAA',
    'AAAAAAAAAAAAAAAHZGVwb3NpdAAAAAACAAAAAAAAAAZhbW91bnQAAAAAAAsAAAAAAAAAB2FkZHJlc3MAAAAAEwAAAAA=',
    'AAAAAAAAAAAAAAAId2l0aGRyYXcAAAACAAAAAAAAAAdhZGRyZXNzAAAAABMAAAAAAAAAGWFjY2VwdF9wcmVtYXR1cmVfd2l0aGRyYXcAAAAAAAABAAAAAA==',
    'AAAAAAAAAAAAAAATZ2V0X2VzdGltYXRlZF95aWVsZAAAAAABAAAAAAAAAAdhZGRyZXNzAAAAABMAAAABAAAACw==',
    'AAAAAAAAAAAAAAAMZ2V0X3Bvc2l0aW9uAAAAAQAAAAAAAAAHYWRkcmVzcwAAAAATAAAAAQAAAAs=',
    'AAAAAAAAAAAAAAAgZ2V0X2VzdGltYXRlZF9wcmVtYXR1cmVfd2l0aGRyYXcAAAABAAAAAAAAAAdhZGRyZXNzAAAAABMAAAABAAAACw==',
    'AAAAAAAAAAAAAAANZ2V0X3RpbWVfbGVmdAAAAAAAAAEAAAAAAAAAB2FkZHJlc3MAAAAAEwAAAAEAAAAG',
    'AAAAAAAAAAAAAAAYZXh0ZW5kX2NvbnRyYWN0X3ZhbGlkaXR5AAAAAAAAAAA=',
    'AAAAAQAAAAAAAAAAAAAAC0RlcG9zaXREYXRhAAAAAAIAAAAAAAAABmFtb3VudAAAAAAACwAAAAAAAAAJdGltZXN0YW1wAAAAAAAABg==',
    'AAAAAgAAAAAAAAAAAAAAB0RhdGFLZXkAAAAACAAAAAAAAAAAAAAABUFkbWluAAAAAAAAAAAAAAAAAAAFQXNzZXQAAAAAAAAAAAAAAAAAAAxDb21wb3VuZFN0ZXAAAAAAAAAAAAAAAARUZXJtAAAAAAAAAAAAAAAJWWllbGRSYXRlAAAAAAAAAAAAAAAAAAAKTWluRGVwb3NpdAAAAAAAAAAAAAAAAAALUGVuYWx0eVJhdGUAAAAAAQAAAAAAAAAHRGVwb3NpdAAAAAABAAAAEw==',
]);
